export const INVOICE_TYPE_LABELS: Record<string, string> = {
  service_desk: 'Service Desk',
  time_and_materials: 'Time & Materials',
  engagement: 'Engagement',
  project: 'Project',
  contract: 'Contract',
  ad_hoc: 'Ad Hoc',
  credit_memo: 'Credit Memo',
  // Legacy values — display gracefully, never write back
  one_time: 'Ad Hoc',
  recurring: 'Contract',
  invoice: 'Time & Materials',
};

export function invoiceTypeLabel(type: string | null | undefined): string {
  if (!type) return '—';
  return INVOICE_TYPE_LABELS[type] ?? type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export const INVOICE_TYPE_OPTIONS = [
  { value: 'service_desk', label: 'Service Desk' },
  { value: 'time_and_materials', label: 'Time & Materials' },
  { value: 'engagement', label: 'Engagement' },
  { value: 'project', label: 'Project' },
  { value: 'contract', label: 'Contract' },
  { value: 'ad_hoc', label: 'Ad Hoc' },
  { value: 'credit_memo', label: 'Credit Memo' },
];